import * as R from 'ramda';

const defaultState = {
  byId: {},
  keyWindows: [],
};

export const fetchQueryResults = (keyWindow, query) => ({
  type: 'FETCH_QUERY_RESULTS',
  payload: {
    keyWindow,
    isFetching: true,
    query,
  },
  random: Math.random(),
});

export const receiveQueryResults = (keyWindow, results) => {
  return ({
    type: 'RECEIVE_ENTITIES',
    payload: {
      keyWindow,
      entities: {
        queryResults: {
          byId: R.indexBy(R.prop('id'), results),
          ids: R.pluck('id')(results),
        },
      },
    },
  });
};

export const receiveQueryErrors = (keyWindow, errors) => {
  return ({
    type: 'RECEIVE_ERRORS',
    payload: {
      keyWindow,
      errors,
    },
  });
};

export default function reducer(state = defaultState, action) {
  switch (action.type) {
    case 'SAVE_QUERY_RESULTS':
    case 'FETCH_QUERY_RESULTS':
      return {
        ...state,
        keyWindows: [...new Set([...state.keyWindows, action.payload.keyWindow])],
        [action.payload.keyWindow]: {
          ...state[action.payload.keyWindow],
          isLoading: true,
        },
      };
    case 'DEFINE_QUERY_RESULTS':
      return {
        ...state,
        draftsById: {
          ...state.draftsById,
          [action.payload.id]: {
            ...action.payload.props,
            id: action.payload.id,
          },
        },
        keyWindows: [...new Set([...state.keyWindows, action.payload.keyWindow])],
        [action.payload.keyWindow]: {
          ...state[action.payload.keyWindow],
          isLoading: false,
          ids: [action.payload.id],
        },
      };
    case 'RECEIVE_ENTITIES':
      return {
        ...state,
        byId: {
          ...state.byId,
          ...R.path(['payload', 'entities', 'queryResults', 'byId'], action),
        },
        keyWindows: [...new Set([...state.keyWindows, action.payload.keyWindow])],
        [action.payload.keyWindow]: {
          ...state[action.payload.keyWindow],
          isLoading: false,
          errors: undefined,
          ids: R.path(['payload', 'entities', 'queryResults', 'ids'], action),
        },
      };
    case 'RECEIVE_ERRORS':
      return {
        ...state,
        keyWindows: [...new Set([...state.keyWindows, action.payload.keyWindow])],
        [action.payload.keyWindow]: {
          ...state[action.payload.keyWindow],
          errors: R.path(['payload', 'errors', 'queryResults'], action),
          isLoading: false,
        },
      };
    case 'RELEASE_KEY_WINDOW':
      return {
        ...R.omit([action.payload.keyWindow], state),
        keyWindows: state.keyWindows.filter(kw => kw !== action.payload.keyWindow),
      };
    default:
      return state;
  }
}
